import Highcharts from 'highcharts';
import addMore from "highcharts/highcharts-more";
import addDrilldown from "highcharts/modules/drilldown";
import addNoData from "highcharts/modules/no-data-to-display";
import addExporting from "highcharts/modules/exporting";

addMore(Highcharts)
addDrilldown(Highcharts)
addNoData(Highcharts)
addExporting(Highcharts)

/**
 * Event stats
 */
class EventStats {

    constructor(eventId, chartData, pieData, settings) {
        var that = this;

        this.eventId = 0;
        this.chartData = {
            views: [],
            attend: [],
            notsure: [],
            cannot: [],
            notinterested: []
        };
        this.pieData = {
            noAction: 0,
            attend: 0,
            notsure: 0,
            cannot: 0,
            notinterested: 0,
        };
        this.settings = {};
        this.texts = {};

        this.locked = false;
        this.chart = null;


        this.eventId = eventId;
        this.chartData = chartData;
        this.pieData = pieData;
        this.creationDate = settings.creationDate;
        this.creationYear = settings.creationYear;
        this.creationMonth = settings.creationMonth;
        this.creationDay = settings.creationDay;
        this.texts = settings.texts;

        if (pieData.noAction + pieData.attend + pieData.notsure + pieData.cannot + pieData.notinterested <= 0 && chartData.views.uniqueViews == 0) {
            $("#chart").css('display', 'none');
            return;
        }

        this.initCharts();
    }

    _lock() {
        this.locked = true;
    }

    _unlock() {
        this.locked = false;
    }

    initCharts() {
        // Line chart
        var that = this;

        this.chart = new Highcharts.Chart({
            chart: {
                renderTo: 'chart',
                type: 'spline',
                zoomType: 'x'
            },
            title: null,
            xAxis: {
                type: 'datetime',
                dateTimeLabelFormats: {
                    day: '%e. %b',
                    week: '%e. %b',
                    month: '%b \'%y',
                    year: '%Y'
                }
            },
            yAxis: {
                title: null,
                min: 0
            },
            tooltip: {
                crosshairs: true,
                formatter: function() {
                    if (this.point.name) { // the pie chart
                        //return '' + this.point.name +': <b>' + (Math.round(this.percentage * 10) / 10) + '%</b> (' + this.y + ')';
                        return '' + this.point.name +': <b>' + this.y + '</b>';
                    } else {
                        return '' +
                        Highcharts.dateFormat('%e. %b %Y', this.x) + ': ' + this.y + ' ' + (this.series.name).toLowerCase();
                    }
                }
            },
            plotOptions: {
                spline: {
                    lineWidth: 2,
                    states: {
                        hover: {
                            lineWidth: 3
                        }
                    },
                    marker: {
                        enabled: false,
                        states: {
                            hover: {
                                enabled: true,
                                symbol: 'circle',
                                radius: 5,
                                lineWidth: 1
                            }
                        }
                    },
                    pointStart: Date.UTC(that.creationYear, that.creationMonth - 1, that.creationDay),
                    pointInterval: 24 * 3600 * 1000 // one day
                },
                pie: {
                    //size: '40%',
                    allowPointSelect: true,
                    cursor: 'pointer',
                    center: [500, 70],
                    size: 80,
                    showInLegend: false,
                    dataLabels: {
                        distance: 20,
                        verticalAlign: 'top',
                        crop: true,
                        enabled: true,
                        formatter: function() {
                            return '<b>'+ this.point.name +'</b>: '+ (Math.round(this.percentage * 10) / 10) +' %';
                        }
                    }
                }
            },
            series: [{
                name: 'Views',
                data: this.chartData.views
            },{
                name: 'Attending',
                data: this.chartData.attend
            },{
                name: 'Interested',
                data: this.chartData.notsure
            },
            // {
            //     name: 'Love it but can\'t',
            //     data: this.chartData.cannot
            // },{
            //     name: 'Not interested',
            //     data: this.chartData.notinterested
            // }, 
            {
                type: 'pie',
                name: 'Browser share',
                data: [
                    {name: 'No action', color: '#eeeeee', y: this.pieData.noAction},
                    {name: 'Attending', color: '#4FB260', y: this.pieData.attend, sliced: true, selected: true},
                    {name: 'Interested', color: '#FDAD17', y: this.pieData.notsure},
                    // {name: 'Love it but can\'t', color: '#CE5AA4', y: this.pieData.cannot},
                    // {name: 'Not interested', color: '#556DB9', y: this.pieData.notinterested}
                ]
            }]
        });
    }
}

export { EventStats }
